export const hasValidToken = (): boolean => {
  const authToken = localStorage.getItem('authToken');
  const tokenExpiry = localStorage.getItem('tokenExpiry');

  const currentDate = new Date();

  if (tokenExpiry) {
    const tokenDate = new Date(tokenExpiry);
    tokenDate.setHours(tokenDate.getHours() + 1);
    const isTokenValid = !!authToken && tokenDate >= currentDate;

    if (!isTokenValid) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('tokenExpiry');
      localStorage.removeItem('queryTokenSession');
    }

    return isTokenValid;
  }

  return false;
};

export const isSBXBetEnvironment = (config: string):
 boolean => ['S2B', 'P2SB', 'P2CDL', 'P2CSTAR', 'P2PLINCO', 'P2IBET', 'P2EDGG', 'P2ALOP'].includes(config); // p2edgg is same as p2ibet, temporary until migration is done

export const isMotherhoodOrP2Environment = (config: string): boolean => (
  config === 'MHS' || isSBXBetEnvironment(config)
);
